import { loadStripe } from '@stripe/stripe-js/pure'
import { stripeKey } from '@/util/EnvValueProvider'

const VueStripe = {
    install: async Vue => {
        loadStripe.setLoadParameters({ advancedFraudSignals: false })
        const stripe = await loadStripe(stripeKey)

        // Use Vue.prototype for Vue 2
        Vue.prototype.$stripe = stripe
    },
}

export default VueStripe
